import axios from 'axios';
import { INDEXER_ENDPOINT } from '~/config.js';

const http = axios.create({
    baseURL: `${INDEXER_ENDPOINT}/stats/`,
});

/**
 * The latest GRAM quote in usd: price, volume, market cap, dominance, rank.
 *
 * @return {Promise<Object>} { source, rank, quotes: { usd: { … } }, … }
 */
export const getMarketQuotes = function () {
    return http.get('quotes').then(({ data }) => Object.freeze(data));
};

/**
 * The suspended early-miner wallets (config param 44), balances in GRAM.
 *
 * @return {Promise<Object>} { suspended_until, updated_at, total, wallets: [{ address, balance }] }
 */
export const getSuspendedWallets = function () {
    return http.get('suspended').then(({ data }) => data);
};

/**
 * The GRAM unlock schedule: every series on one time grid, `t` in seconds.
 *
 * @return {Promise<Object>} { anchor, t, vesting, locker, suspended }
 */
export const getUnlocks = function () {
    return http.get('unlocks').then(({ data }) => data);
};

/**
 * Accounts and supply by day, the newest 500 days (nanograms as strings).
 *
 * @return {Promise<Array>} [{ date, timestamp, total_accounts, total_supply, circulating_supply, initiated_supply }]
 */
export const getStatus = function getBlockchainBasicMetricsHistory() {
    return http.get('status').then(({ data }) => data);
};

/**
 * Staking yield by validation round, the newest 500 rounds.
 *
 * @return {Promise<Array>} [{ date, staked, rewarded, annual_percent_yld }]
 */
export const getStakingInformation = async function getStakingYieldAndApyHistory() {
    const { data } = await http.get('yield');

    return data.map(({ date, ...item }) => ({
        date: date.replace('Z', ''),
        ...item,
    }));
};

/**
 * Transactions by day, the newest 500 days.
 *
 * @return {Promise<Array>} [{ date, from_timestamp, to_timestamp, transactions_count, users_transactions_count }]
 */
export const getTxCount = function getTxCountHistory() {
    return http.get('transactions_count').then(({ data }) => data);
};
